// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oc-9";
export var arrowButtonContainer = "_oc-5";
export var arrowButtonIcon = "_oc-6";
export var carouselArrowButton = "_oc-2";
export var carouselElementContainer = "_oc-1";
export var currentSlide = "_oc-8";
export var left = "_oc-3";
export var otherSlide = "_oc-a";
export var productCarouselContainer = "_oc-0";
export var right = "_oc-4";
export var sliderOverflow = "_oc-7";